export default {
    grecaptcha: {
        siteKey: "6LcHYvEtAAAAAIcw718Hy6CBS93MzQ5jqXBUn_tg",
        contactFormUrl: "/api/contact",
        projectFormUrl: "/api/proposal"
    }
}
